import { FC } from 'react'
import Breadcrumb from 'components/Breadcrumb'
import Typography from 'components/Typography'
import {
  getListingSearchBreadcrumbList,
  TGetSearchListingBreadcrumbList,
} from 'lib/breadcrumb'
import styles from './BreadcrumbSection.module.scss'

export type TProps = {
  breadcrumbListing: TGetSearchListingBreadcrumbList
}

const BreadcrumbSection: FC<TProps> = ({ breadcrumbListing }) => {
  const breadcrumbList = getListingSearchBreadcrumbList(breadcrumbListing)

  if (breadcrumbList.length === 0) return null

  return (
    <div className={styles.ecBreadcrumbSection}>
      <Typography variant="Title" bold>
        Continue sua busca por imóveis
      </Typography>
      <Breadcrumb list={breadcrumbList} />
    </div>
  )
}

export default BreadcrumbSection
